import React, { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { api } from "@/lib/api";

export const TeacherTestimonials = ({ fallback = [], className = "mt-8" }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials?audience=teacher").then(({ data }) => setItems(data.testimonials?.length ? data.testimonials : fallback)).catch(() => setItems(fallback));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!items.length) return null;

  return (
    <div className={className} data-testid="teacher-testimonials">
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary">What teachers say</p>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.slice(0, 6).map((t, i) => (
          <figure key={t.id || i} className="rounded-2xl border border-border bg-background p-5" data-testid={`teacher-testimonial-${t.id || i}`}>
            <Quote size={18} className="text-primary" />
            <blockquote className="mt-2 text-sm text-muted-foreground">"{t.quote}"</blockquote>
            <figcaption className="mt-3 text-sm">{t.name && <span className="font-semibold text-foreground">{t.name}</span>}{t.role && <span className="text-muted-foreground">{t.name ? " · " : ""}{t.role}</span>}</figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
};
